// Widget scripts
import eventFeed from './js/widgets/eventFeed.js';
import countdownTextImage from './js/widgets/countdownTextImage.js';
import footerWidget from './js/widgets/footerWidget.js';
import headerButtons from './js/widgets/headerButtons.js';
import homepagePopup from './js/widgets/homepagePopup';
import hotButtons from './js/widgets/hotButtons';
import imageWidget from './js/widgets/imageWidget';
import mainFeature from './js/widgets/mainFeature.js';
import premierSponsors from './js/widgets/premierSponsors';
import seoWidget from './js/widgets/seoWidget.js';
import hashtagTitle from './js/widgets/hashtagTitle.js';
import { instafeed } from './js/widgets/socialNetworkWidget';
import siteMapLinks from './js/widgets/siteMapLinks';

import AOS from 'aos';
import 'aos/dist/aos.css';

// Custom theme scripts
import './js/localjs.js';

// Initialize homepage widgets
if (window.location.pathname === '/') {
  $(document).ready(function() {
    eventFeed();
    homepagePopup();
    hotButtons();
    countdownTextImage();

    imageWidget();
    mainFeature();
    seoWidget();
    hashtagTitle();
    instafeed(true);
  });
}

// Initialize sitewide widgets
$(document).ready(function() {
  headerButtons();
  premierSponsors();
  footerWidget();
  siteMapLinks();

  setTimeout(() => {
    AOS.init({
      anchorPlacement: 'bottom-bottom',
      animatedClassName: 'aos-animate',
      initClassName: 'aos-init',
    });
  }, 2000)

});